import React from 'react';
  
const authContext = React.createContext({auth: null});
  
export default authContext;